import { gql } from '@apollo/client'

export const CREATE_SUBMISSION = gql`
  mutation ApplyMutation($data: String!, $opportunity_form_id: Int!) {
    createSubmission(data: $data, opportunity_form_id: $opportunity_form_id) {
        id
    }
  }
`